// src\styles\breakpoints.ts
const breakpoints = {
  values: {
    xs: 0,
    sm: 768,
    md: 992,
    lg: 1366,
    xl: 1536,
  }
};

export default breakpoints;